import { Metadata } from "../../shared/models/metadata.model";
import { ChatbotServiceImpl } from "./chatbot/chatbot.impl";
import { ChatbotService } from "./chatbot/chatbot.service";
import { ChatbotServiceLocal } from "./chatbot/chatbot.local";
import { ContextServiceLocal } from "./context/context.local";
import { ContextService } from "./context/context.service";
import { FileServiceLocal } from "./file/file.local";
import { FileService } from "./file/file.service";
import { FormServiceImpl } from "./form/form.impl";
import { FormServiceLocal } from "./form/form.local";
import { FormService } from "./form/form.service";
import { MetadataServiceLocal } from "./search/search.local";
import { SearchService } from "./search/search.service";
import { ContextServiceImpl, FileServiceImpl, MetadataServiceImpl } from "../../client-shared/api";
import { AuthService } from "./auth/auth.service";
import { AuthServiceLocal } from "./auth/auth.local";
import { AuthServiceImpl } from "./auth/auth.impl";


declare global {
    interface Window { _download_metadata: Array<Metadata>; }
}

export const getAppServices = () => {
    return new Services("impl", "", undefined);
}

/***
 * Wrapper class to provide all the services either local or api.
 */
export class Services {
    /**
    * Handle links and file operations
    * @type {FileService}
    */
    file: FileService;

    /**
     * Handle operations that related to source items like settings, organization, property values, etc.
     * @type {ContextService}
     */
    context: ContextService;

    /**
     * Handle search operation
     * @type {SearchService}
     */
    search: SearchService;

    /**
     * Handle chatbot operation
     * @type {ChatbotService}
     */
    chatbot: ChatbotService;

    /**
     * Handle form submit
     * @type {FormService}
     */
    form: FormService;

    auth: AuthService;

    /**
     * @param {string} type - The type of storage to use
     *  - local: Use local storage
     *  - mock: Use mock data
     *  - default: Use API calls
     * @param {string} currentPath - The current path used for local configuration
     */
    constructor(type?: string, currentPath?: string, showSnackbar?: (message: string, severity: string) => void) {
        const appAPIUrl = process.env.REACT_APP_API_URL || "/api/app";
        switch (type) {
            case "local":
                this.file = new FileServiceLocal(currentPath || "/");
                this.context = new ContextServiceLocal();
                this.search = new MetadataServiceLocal();
                this.chatbot = new ChatbotServiceLocal();
                this.form = new FormServiceLocal();
                this.auth = new AuthServiceLocal();
                break;
            default:
                this.file = new FileServiceImpl(appAPIUrl, showSnackbar!);
                this.context = new ContextServiceImpl(appAPIUrl, showSnackbar!);
                this.search = new MetadataServiceImpl(appAPIUrl, showSnackbar!);
                this.chatbot = new ChatbotServiceImpl(appAPIUrl, showSnackbar!);
                this.form = new FormServiceImpl(appAPIUrl, showSnackbar!);
                this.auth = new AuthServiceImpl(appAPIUrl, showSnackbar!);
                break;
        }
    }
}

